import { gql } from '../generated/cache';

export const getCachePoolsQuery = gql(/* GraphQL */ `
  query GetCachePools($baseAsset: ChainflipAsset) {
    pools: allPools(condition: { baseAsset: $baseAsset }) {
      nodes {
        baseAsset
        quoteAsset
        buyPrice
        rangeOrderPrice
        baseLiquidityAmount
        quoteLiquidityAmount
        liquidityFeeHundredthPips
      }
    }
  }
`);

export const getCachePoolsWithOrdersQuery = gql(/* GraphQL */ `
  query GetCachePoolsWithOrder($baseAsset: ChainflipAsset) {
    pools: allPools(condition: { baseAsset: $baseAsset }) {
      nodes {
        baseAsset
        quoteAsset
        buyPrice
        rangeOrderPrice
        baseLiquidityAmount
        quoteLiquidityAmount
        liquidityFeeHundredthPips
        openOrders
      }
    }
  }
`);
